import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface Props extends Omit<ButtonProps, 'variant'> {
  variant?: 'outlined' | 'contained' | 'text';
  customBackground?: string;
  borderRadius?: string;
}

const CustomButton: React.FC<Props> = ({
  children,
  variant = 'outlined',
  onClick,
  className,
  customBackground,
  borderRadius = '50px',
  sx = {},
  ...props
}) => {
  const isCustomBackground = customBackground === '#FDF9F6';

  const finalBorderRadius = (sx as any).borderRadius || borderRadius;
  const finalBorderColor = (sx as any).borderColor || '#46558D';
  const finalColor = isCustomBackground
    ? '#46558D'
    : variant === 'outlined'
    ? '#46558D'
    : '#FFFFFF';
  const finalBackgroundColor = isCustomBackground
    ? '#FDF9F6'
    : variant === 'contained'
    ? customBackground || '#46558D'
    : 'transparent';

  return (
    <Button
      variant={variant}
      className={className}
      onClick={onClick}
      sx={{
        borderColor: finalBorderColor,
        color: finalColor,
        backgroundColor: finalBackgroundColor,
        textTransform: 'none',
        padding: { xs: '8px 16px', sm: '10px 24px' },
        fontWeight: 600,
        fontSize: { xs: '14px', sm: '16px' },
        minWidth: 'auto',
        '&:hover': {
          borderColor: '#3a4a75',
          backgroundColor: isCustomBackground
            ? '#F5F0E8'
            : variant === 'outlined'
            ? 'rgba(70, 85, 141, 0.04)'
            : '#3a4a75',
          color: isCustomBackground ? '#3a4a75' : variant === 'outlined' ? '#3a4a75' : '#FFFFFF',
        },
        ...sx,
        borderRadius: finalBorderRadius,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
